import React from 'react';
import ReactTable from "react-table";
import { Row, Col, Button } from 'react-bootstrap';

import "react-table/react-table.css";

import 'bootstrap/dist/css/bootstrap.css';
import { uniq } from 'underscore';
import FontAwesome from 'react-fontawesome';
import constants from '../../../util/constants';
import axios from 'axios';
import moment from 'moment';
import { export2Excel, filterNumber, filterMultiple, getFilteredData, getSum, setDataForExpansion, getTextColumn, getLabelColumn } from '../../../gridHelpers/gridHelpers';
import LoadingSpinner from '../../../LoadingSpinner';
import NPHelpButton from '../../../NPHelpButton';
import './style.scss';
import _ from 'underscore';
import NPReactTable from '../../../NPReactTable';
import * as Grants from '../../.././util/grants';
import { hasGrant } from '../../../util/grantHelper';
import ReactGA from 'react-ga';
import * as Convert from '../../../util/unitConversion'

const { API_BASE_URL } = constants;

class LogisticsDataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getClearedState();
        this.state.refreshCounter = props.refreshCounter;
        this.resetState = this.resetState.bind(this);
        this.help = this.help.bind(this);
        this.excelExport = this.excelExport.bind(this);
        this.getcolumns = this.getcolumns.bind(this);
        this.getClearedState = this.getClearedState.bind(this);
        this.getData = this.getData.bind(this);
        this.resetState = this.resetState.bind(this);
        this.onSelectRow = this.onSelectRow.bind(this);
        this.canRowOpenReleased = this.canRowOpenReleased.bind(this);
    }

    componentDidMount() {
        this.axiosCancelSource = axios.CancelToken.source();
        this.setState({internal: window.sessionStorage.getItem('UserType') == 1});
        this.getData(true);
    }
    componentWillUnmount() {
        this.axiosCancelSource.cancel('Component unmounted.')
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.refreshCounter != this.props.refreshCounter) {
            this.getData();
        }
    }

    onSelectRow(row) {
        this.props.onSelectRow(row.original);
    }

    resetState() {
        this.setState(this.getClearedState());
    }

    canRowOpenReleased(row){
        return hasGrant(Grants.TYPES.Stock_SetCallOffBackToPreliminary) && row.original.STATUS_ID === 9;
    }

    handleSelectChange(evt, action, row, self) {
        row = row.original || row;
        if (row) {
            if (action === 'release') {
                self.props.callOffFunctions.release(row, self.getData);
            }
            else if (action === 'modify') {
                self.props.callOffFunctions.modify(row);
            }
            else if (action === 'open'){
                self.props.callOffFunctions.openReleased(row, self.getData);
            }
        }
        evt.currentTarget.selectedIndex = 0;
    }

    getcolumns() {
        let self = this;
        const helpNode = (
            <div>
                <h3>Buttons</h3>

                <h4>Reset</h4>
                <p>Resets filters, sorting, column widths and navigates to first page.</p>

                <h4>Excel</h4>
                <p>Exports the data to excel according to filters and sorting.</p>

                <h3>Filters</h3>

                <p>There are fields at the top of the table that can be used for filtering</p>

                <p>
                    If a text box for a column is empty, no filtering for that column will be done.<br />
                    If the data is left-aligned and the text box is not empty, the filter will remove rows that do not contain the text in the text box<br />
                    It is possible to use multiple filters for text based values by writing a comma, for example "Ordered, Being produced"<br /><br />
                    Examples follows for right-aligned (numbers):<br />
                    Empty text box, no filtering.<br />
                    <strong>&lt; 10</strong> view rows with data that is less than 10<br />
                    <strong>&gt; 10</strong> view rows with data that is more than 10<br />
                    <strong>20-30</strong> view rows with data that is between 20 and 30.
                </p>
            </div>
        )

        return ([
            {
                Header: <div className="shipping">Shipping information</div>,
                headerStyle: { background: '#DDDDDD' },
                columns: [
                    {
                        Header: "",
                        maxWidth: 30,
                        Filter: ({ filter, onChange }) =>
                            <NPHelpButton content={helpNode} title="Help" />,
                        sortable: false,
                        show: hasGrant(Grants.TYPES.Stock_CreateCalloff),
                        Cell: (row) => {
                            if (row.original.STATUS_ID == 8 || this.canRowOpenReleased(row)) 
                                return (
                                    <span>
                                        <select className='tst myopt handy' onChange={evt => { this.handleSelectChange(evt, evt.target.value, row, this) }}>
                                            <option value="">...</option>
                                            {row.original.STATUS_ID == 8 ? <option value="modify">Modify Call Off</option> : ''}
                                            {row.original.STATUS_ID == 8 ? <option value="release">Release Call Off</option> : ''}
                                            {(this.canRowOpenReleased(row)) ? <option value="open">Set status back to preliminary</option> : ''}
                                        </select>
                                    </span>
                                )
                        }
                    },
                    {
                        Header: "Loading no",
                        accessor: "LOADING_NO",
                        maxWidth: 100,
                    },
                    getLabelColumn("Order no", "DISTINCT_ORDERS", 150, self, true),
                    {
                        Header: "Client",
                        accessor: "CLIENT_CODE_REGIONAL",
                        maxWidth: 80,
                    },
                    {
                        Header: "Name",
                        accessor: "SHORT_NAME",
                        maxWidth: 80,
                    },
                    {
                        Header: "Country",
                        accessor: "END_COUNTRY",
                        maxWidth: 80,
                    },
                    {
                        Header: "Status",
                        accessor: "STATUS_DESCRIPTION",
                        maxWidth: 100,
                    },
                    {
                        Header: "Customer service specialist",
                        show: this.state.internal,
                        accessor: "MARKETASSISTANT",
                        maxWidth: 110,
                    },
                    {
                        Header: "Pl. quantity",
                        accessor: "PLANNED_QUANTITY",
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.plannedquantityTotal}</strong>{" "}
                            </span>
                        ),
                        maxWidth: 80,
                    },
                    {
                        Header: <Convert.TextTo value_metric={"Pl. weight (kg)"} value_imperial={"Pl. weight (lb)"}/>,
                        accessor: "PLANNED_WEIGHT_UC",
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.plannedweightTotal}</strong>{" "}
                            </span>
                        ),
                        maxWidth: 100,
                    },
                    {
                        Header: "Shipped quantity",
                        accessor: "SHIPPED_QUANTITY",
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.shippedquantityTotal}</strong>{" "}
                            </span>
                        ),
                        minWidth: 110,
                    },
                    {
                        Header: <Convert.TextTo value_metric={"Shipped weight (kg)"} value_imperial={"Shipped weight (lb)"}/>,
                        accessor: "SHIPPED_WEIGHT_UC",
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.shippedweightTotal}</strong>{" "}
                            </span>
                        ),
                        minWidth: 120,
                    },
                    {
                        Header: "Loading date",
                        accessor: "LOADING_DATE",
                        minWidth: 100,
                    },
                    {
                        Header: "ETA",
                        accessor: "ESTIM_ARRIVAL_DATE",
                        maxWidth: 120,
                    },
                    {
                        Header: "Delivery code",
                        accessor: "DELIVERY_CODE",
                        minWidth: 100,
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "Delivery destination",
                        accessor: "DELIVERY_DESTINATION",
                        minWidth: 120,
                    },
                    {
                        Header: "Reported note",
                        accessor: "REPORTED_NOTE",
                        maxWidth: 90,
                    },
                    {
                        Header: "Transporter",
                        accessor: "TRANSPORTER_SHORT_NAME",
                        minWidth: 100,
                    },
                    {
                        Header: "Sales office",
                        accessor: "SALES_OFFICE",
                        maxWidth: 80,
                    },
                    {
                        Header: "Transport type",
                        accessor: "TRANSPORT_TYPE_DESCRIPTION",
                        minWidth: 120,
                    },
                    {
                        Header: "Container type",
                        accessor: "TYPE_DESCRIPTION",
                        maxWidth: 100,
                    },
                    {
                        Header: "Truck",
                        accessor: "TRUCK_NO",
                        maxWidth: 80,
                    },
                    {
                        Header: "Freight",
                        accessor: "FREIGHT_NO",
                        maxWidth: 80,
                    },
                    getLabelColumn("Invoice", "DISTINCT_INVOICE_NO", 150, self, true),
                ]
            },

        ]);
    }

    getClearedState(init) {
        return ({
            sorted: [],
            internal: false,
            page: 0,
            pageSize: 10,
            expanded: {},
            resized: [],
            filtered: [],
            showModal: false,
            selectedProductCode: '',
            productCodeFilter: null,
            clientFilter: null
        });
    }

    help() {
        alert('Buttons:\nReset: Resets filters, sorting, column widths and sets page to page 1.\n' +
            'Excel: Exports the data to excel according to filters and sorting.\n\n' +
            'Filters:\nBelow the columns filter we have input text boxes that can be used for filtering\n' +
            'If a text-box for a column is empty, no filtering for that column will be done.\n' +
            'If the data is left-aligned and the text-box is not empty, the filter will remove rows that do not contain the the text in the text-box.\n' +
            'Examples follows for right-aligned (numbers):\n' +
            'Empty text-box, no filtering.\n>10 filters rows with column data with 10 or less\n' +
            '<10 filters rows with column data 10 or more\n20-30 filters rows with data that is not between 20 and 30.');
    }

    excelExport() {
        export2Excel(this.props.apiToken, this.reactTable.getReactTable(), "Dashboard_logictics.xlsx");
        this.GAtrackHandler();
    }

    GAtrackHandler(e) {
        ReactGA.event({
            category: "User action",
            action: "Logictics was exported as Excel from dashboard",
        });
    }

    tell(txt, row) {
        setDataForExpansion(txt, row, this.props.apiToken, this);
    }

    getOptionLabelAndValue(values) {
        values.sort();
        values = uniq(values);
        return values.map(v => ({ value: v, label: v }));
    }


    getData() {
        let self = this;

        this.setState({ isLoading: true });

        const header = {
            'Authorization': 'Bearer ' + this.props.apiToken,
            'Accept': 'application/octet-stream'
        };

        axios.get(API_BASE_URL + 'CallOff/GetLogisticsData', { headers: header, cancelToken: this.axiosCancelSource.token })
            .then(result => {
                self.setState({ data: result.data, isLoading: false });
            })
            .catch(response => {
                self.setState({ isLoading: false });
            });

    }

    render() {
        const data = this.state.data;
        if (!data || this.state.isLoading) {
            return <LoadingSpinner isLoading={true} />
        }

        return (
            <Row className="margin-top-10">
                <Col xs={12} className="margin-top-10">
                    <Button bsStyle="primary" bsSize="small" onClick={this.resetState}>Reset</Button>
                    <Button bsStyle="primary" bsSize="small" className="pull-right" onClick={this.getData}>Refresh</Button>
                    {hasGrant(Grants.TYPES.Stock_CreateCalloff) && <Button bsStyle="primary" bsSize="small" className="margin-left-10" onClick={(evt) => this.props.callOffFunctions.create()}>New Call Off</Button>}
                </Col>

                <Col xs={12} className="margin-top-10">
                    <NPReactTable
                        className="np-react-table"
                        data={data}
                        ref={(r) => { this.reactTable = r }}
                        columns={this.getcolumns()}
                        defaultFilterMethod={filterMultiple}
                        filterable
                        filterAll
                        defaultPageSize={10}
                        // Controlled props
                        sorted={this.state.sorted}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        expanded={this.state.expanded}
                        resized={this.state.resized}
                        filtered={this.state.filtered}
                        // Callbacks
                        onSortedChange={sorted => this.setState({ sorted, expanded: {} })}
                        onPageChange={
                            page => {
                                this.setState({ page, expanded: {} });
                            }

                        }
                        onPageSizeChange={(pageSize, page) => {
                            this.setState({ page, pageSize, expanded: {} });
                        }
                        }
                        onResizedChange={resized => this.setState({ resized })}
                        onFilteredChange={filtered => {
                            this.setState({ filtered, page: 0, expanded: {} })
                        }
                        }
                    />
                </Col>

            </Row>
        );
    }
}

export default LogisticsDataTable;